import "./credits.scss";
import { Edit3Icon } from "lucide-react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { fetchClientsByOrganization } from "../../../store/UserSlice";
import { fetchCreditsByOrganization } from "../../../store/DepositsSlice";
import EditCreditStatusModal from "../../../components/modal/modal-edit-credit-status/modal-edit-credit-status";

import { DataList, DataListColumn, FormField, StatusBadge, MoneyValue } from "../../../components/ui";

const CREDIT_STATUSES = ["ALL", "PENDING", "PAID", "CANCELLED", "APPROVED"];
const DEFAULT_FILTERS = { userId: null as string | null, status: null as string | null };

const Credits = () => {
    const dispatch = useAppDispatch();

    const credits = useAppSelector((state) => state.deposit.creditsList);
    const clients = useAppSelector((state) => state.user.clientList);

    const [filterUser, setFilterUser]     = useState<string>("ALL");
    const [filterStatus, setFilterStatus] = useState<string>("ALL");
    const [editCredit, setEditCredit]     = useState<any | null>(null);

    useEffect(() => {
        dispatch(fetchCreditsByOrganization(DEFAULT_FILTERS));
        dispatch(fetchClientsByOrganization());
    }, [dispatch]);

    const sendFilter = () => {
        dispatch(fetchCreditsByOrganization({
            userId: filterUser   === "ALL" ? null : filterUser,
            status: filterStatus === "ALL" ? null : filterStatus,
        }));
    };

    const columns: DataListColumn<any>[] = [
        {
            key: "currency",
            header: "Currency",
            width: "1.2fr",
            render: (c) => (
                <span className="cell-stack">
                    <strong>{c.asset?.name}</strong>
                    <small className="num">{c.trx_id}</small>
                </span>
            ),
        },
        { key: "origem",    header: "Origem",  render: (c) => <span style={{ opacity: .55 }}>{c.creator?.name}</span> },
        { key: "cliente",   header: "Cliente", render: (c) => c.user?.name },
        { key: "tipo",      header: "Tipo",    render: () => "Credito" },
        { key: "data",      header: "Data",    render: (c) => <span style={{ opacity: .55 }}>{c.createdAt}</span>, mono: true },
        { key: "valor",     header: "Valor",   render: (c) => <MoneyValue amount={c.value} tone="up" />, align: "right" },
        { key: "status",    header: "Status",  render: (c) => <StatusBadge status={c.status} /> },
        {
            key: "actions",
            header: "",
            width: "60px",
            align: "center",
            render: (c) => (
                <span
                    role="button"
                    className="edit-btn"
                    onClick={(e) => { e.stopPropagation(); setEditCredit(c); }}
                >
                    <Edit3Icon size={18} />
                </span>
            ),
        },
    ];

    return (
        <div className="credits-page-wrapper">
            <h1 className="page-title">
                Creditos
                <small>lista de todos os creditos da organizacao.</small>
            </h1>

            <div className="filters">
                <FormField label="Usuario">
                    <select value={filterUser} onChange={(e) => setFilterUser(e.target.value)}>
                        <option value="ALL">Todos</option>
                        {clients && clients.map((client: any) => (
                            <option key={client.id} value={String(client.id)}>{client.name}</option>
                        ))}
                    </select>
                </FormField>

                <FormField label="Status">
                    <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                        {CREDIT_STATUSES.map((s) => (
                            <option key={s} value={s}>{s === "ALL" ? "Todos" : s}</option>
                        ))}
                    </select>
                </FormField>

                <button className="btn-pill ghost" onClick={sendFilter}>Filtrar</button>
            </div>

            <DataList
                columns={columns}
                rows={credits ?? []}
                loading={!credits}
                empty="Nenhum credito encontrado."
            />

            {editCredit && (
                <EditCreditStatusModal
                    credit={editCredit}
                    onClose={() => setEditCredit(null)}
                    onSuccess={() => dispatch(fetchCreditsByOrganization(DEFAULT_FILTERS))}
                />
            )}
        </div>
    );
};

export default Credits;
